import { CAR_BATTERY_VEHICLE_TYPE_ID, MOTOR_BATTERY_VEHICLE_TYPE_ID } from '@/constants/batteryProduct';
import { vehicleTypesCategoryId } from '@/constants/common';

import { ProductType } from '@/server/services/core/product/models';
import { ProductBatteryType } from '@/server/services/core/productBattery/models';

type ProductCategoryRef = ProductType['category'] | NonNullable<ProductType['category']['breadcrumbs']>[number];

export const isBatteryCategoryId = (categoryId?: number) =>
    categoryId === vehicleTypesCategoryId.CAR || categoryId === vehicleTypesCategoryId.MOTORCYCLE;

export const getProductBaseCategory = (product: ProductType & Partial<ProductBatteryType>): ProductCategoryRef => {
    return product.category.breadcrumbs[0] ?? product.category;
};

export const isBatteryProduct = (product: ProductType & Partial<ProductBatteryType>): boolean => {
    const { slug } = getProductBaseCategory(product);
    return slug === CAR_BATTERY_VEHICLE_TYPE_ID || slug === MOTOR_BATTERY_VEHICLE_TYPE_ID;
};
